import React from 'react';
import {Card} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SystemTable from '../components/SystemTable';
import {fetchAllSystems, setSystemState} from '../actions/system'

class Systems extends React.Component {
  componentWillMount() {
    this.props.dispatch(fetchAllSystems())
  }

  handleSetSystem = (system) => {
    this.props.dispatch(setSystemState(system))
  }

  render() {
    const {systems, fetching} = this.props
    return <div>
      <Card title="Quản lý hệ thống" bordered={false} className="card">
        <SystemTable systems={systems} fetching={fetching} onSetSystem={this.handleSetSystem}/></Card>
    </div>
  }
}
Systems.propTypes = {
  dispatch: PropTypes.func,
  currentUser: PropTypes.object,
  systems: PropTypes.array,
  fetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {currentUser: state.user.currentUser, systems: state.system.systems, fetching: state.system.fetching, error: state.system.error}
}

export default connect(mapStateToProps)(Systems)



// WEBPACK FOOTER //
// ./src/pages/Systems.js